import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './authContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    // Zeige Ladeindikator während der Authentifizierungsstatus geprüft wird
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <p className="text-lg">Lädt...</p>
        </div>
      </div>
    );
  }
  
  // Wenn nicht authentifiziert, zur Login-Seite umleiten
  if (!user) {
    return <Navigate to="/login" />;
  }
  
  // Wenn authentifiziert, geschützte Komponente rendern
  return children;
};

export default ProtectedRoute;